import React, { useState } from "react";
import '../assets/css/css-code-editor.css';

const CssCodeEditor = ({ code, setCode, onChangeComplete }) => {
    const [lineCount, setLineCount] = useState(1); 

    // Handle code input change
    const handleCodeChange = (e) => {
        const value = e.target.value;
        setCode(value);
        setLineCount(value.split("\n").length);

        // Notify parent component of change (save in DB)
        if (onChangeComplete) {
            onChangeComplete(value);
        }
    };


    // Function to generate line numbers dynamically
    const generateLineNumbers = () => {
        let lines = [];
        for (let i = 1; i <= lineCount; i++) {
            lines.push(i);
        }
        return lines;
    };

    return (
        <div className="editor-container">
            <div className="line-numbers">
                {generateLineNumbers().map((line, index) => (
                    <div key={index} className="line-number">{line}</div>
                ))}
            </div>

            <textarea
                className="code-textarea"
                value={code}
                onChange={handleCodeChange}
                onBlur={() => onChangeComplete && onChangeComplete(code)}
                placeholder="Write your Css code here..."
                rows={lineCount}
            />
        </div>
    );
};

export default CssCodeEditor;
